import gql from 'graphql-tag'

export default function minGql(strs, ...values) {
  let out = []
  Array.from(strs).forEach((s, x) => {
    out.push(s)
    out.push(values[x])
  })
  return gql(
    out
      .join('')
      .replace(/\n/gm, ' ')
      .replace(/\s\s+/g, ' ')
      .replace(/^\s+/g, '')
      .replace(/\s+$/g, '')
      .replace(/\s*([{}])\s*/g, '$1')
  )
}
